/**
 * The visitor app opens this order page in an in-app WebView (order links,
 * marketplace links, "bekijk bestelling"). Showing the "open in app" card
 * there is nonsense — the visitor is already in the app.
 *
 * Detection is primarily the marker the app appends to the WebView's user
 * agent (`applicationNameForUserAgent` on react-native-webview), so it holds
 * for every in-app navigation, including links we don't build ourselves.
 *
 * `?inApp` is accepted as a fallback for surfaces that can't set a user agent
 * (a system browser sheet, for instance). It's latched into sessionStorage
 * because client-side route changes drop the query string.
 */
const USER_AGENT_MARKER = 'FastlaneVisitorApp';
const QUERY_PARAM = 'inApp';
const STORAGE_KEY = 'fastlane.inVisitorApp';

function readLatch(): boolean {
    try {
        return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch {
        // Embedded in a third-party iframe with storage blocked.
        return false;
    }
}

function writeLatch(): void {
    try {
        sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
        // Same — the user agent path still works, so this is best-effort.
    }
}

export function isInVisitorApp(): boolean {
    if (typeof navigator !== 'undefined' && navigator.userAgent.includes(USER_AGENT_MARKER)) {
        return true;
    }
    if (typeof window === 'undefined') {
        return false;
    }
    if (new URLSearchParams(window.location.search).has(QUERY_PARAM)) {
        writeLatch();
        return true;
    }
    return readLatch();
}
